'use client';

interface Props {
  children: React.ReactNode;
  enableBackground?: boolean;
}

export const LayoutRoot = ({ children, enableBackground = false }: Props) => {
  return (
    <div
      data-background={enableBackground ? 'gradient' : undefined}
      className="tw:flex tw:flex-auto tw:flex-col tw:h-full tw:min-h-[calc(100vh-98px)] tw:bg-background"
    >
      {children}
    </div>
  );
};
